var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYellowPie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 76,
    viewBox: "0 0 141 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M140.379 72C140.379 59.7124 137.144 47.6413 131.001 37C124.857 26.3586 116.02 17.522 105.379 11.3782L70.3789 72H140.379Z",
    fill: "#EEEEEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35 11.3782C24.3587 17.522 15.522 26.3586 9.37822 37C3.23444 47.6413 -1.08784e-06 59.7124 0 72L70 72L35 11.3782Z",
    fill: "#FDD63C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M105.866 11.8782L106.366 11.0122L105.5 10.5122C94.7066 4.28064 82.4631 0.999999 70 1C57.5369 1 45.2934 4.28065 34.5 10.5122L33.634 11.0122L34.134 11.8782L69.134 72.5L70 74L70.866 72.5L105.866 11.8782Z",
    fill: "#EEEEEE",
    stroke: "white",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M106.379 72C106.379 62.4522 102.586 53.2955 95.8348 46.5442C89.0834 39.7928 79.9267 36 70.3789 36C60.8311 36 51.6744 39.7928 44.9231 46.5442C38.1718 53.2955 34.3789 62.4522 34.3789 72L106.379 72Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowPie);
export default __webpack_public_path__ + "static/media/yellowPie.167a2882c75a0aaaa3544b28f5862f23.svg";
export { ForwardRef as ReactComponent };